<div class="loading-overlay">
    <div class="loading-container">
        <img src="assets/images/loading.png" alt="Carregando" class="loading-image">
        <p class="font-semibold">Carregando...</p>
    </div>
</div>